export function convertToIndianCurrency(num) {
  const single = ['Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const double = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const triple = ['', 'Thousand', 'Lakh', 'Crore'];

  if (num === 0) return 'Zero Rupees';

  function formatTwoDigit(n) {
    if (n < 10) return single[n];
    if (n < 20) return double[n - 10];
    return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + single[n % 10] : '');
  }

  let words = '';
  let rupees = Math.floor(num);
  let paisa = Math.round((num - rupees) * 100);

  if (rupees > 0) {
    let crore = Math.floor(rupees / 10000000);
    rupees %= 10000000;
    if (crore > 0) words += formatTwoDigit(crore) + ' Crore ';

    let lakh = Math.floor(rupees / 100000);
    rupees %= 100000;
    if (lakh > 0) words += formatTwoDigit(lakh) + ' Lakh ';

    let thousand = Math.floor(rupees / 1000);
    rupees %= 1000;
    if (thousand > 0) words += formatTwoDigit(thousand) + ' Thousand ';

    let hundred = Math.floor(rupees / 100);
    rupees %= 100;
    if (hundred > 0) words += single[hundred] + ' Hundred ';

    if (rupees > 0) words += formatTwoDigit(rupees);

    words += ' Rupees';
  }

  if (paisa > 0) {
    words += ' and ' + formatTwoDigit(paisa) + ' Paise';
  }

  return words.trim();
}